var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningTriangleRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.55286 6.42011V9.75345M9.55286 13.0868H9.56119M8.39895 2.16322L1.54488 14.0021C1.16471 14.6587 0.974626 14.9871 1.00272 15.2565C1.02723 15.4916 1.15037 15.7051 1.3415 15.8441C1.56063 16.0034 1.94002 16.0034 2.69879 16.0034H16.4069C17.1657 16.0034 17.5451 16.0034 17.7642 15.8441C17.9553 15.7051 18.0785 15.4916 18.103 15.2565C18.1311 14.9871 17.941 14.6587 17.5608 14.0021L10.7068 2.16321C10.3279 1.50891 10.1385 1.18176 9.89144 1.07188C9.67589 0.976039 9.42982 0.976039 9.21427 1.07188C8.96717 1.18176 8.77776 1.50891 8.39895 2.16322Z",
    stroke: "var(--stroke-0, #DF3822)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangleRed);
export default __webpack_public_path__ + "static/media/warning-triangle-red.efecf91a944efae7cd471a87854afd23.svg";
export { ForwardRef as ReactComponent };